import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import Swal from "sweetalert2";
import { createAccountHeadThunk, updateAccountHeadThunk } from "../../redux/slices/accountHeadSlice";
import { getApiErrorMessage } from "../../utils/apiError";

const EMPTY = { accountName: "", description: "", status: "Active" };

const statusOptions = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

const AccountHeadModal = ({ show, onClose, editRecord }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm(editRecord ? { ...EMPTY, ...editRecord } : EMPTY);
  }, [editRecord, show]);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  const setSelect = (field) => (opt) => setForm((f) => ({ ...f, [field]: opt?.value ?? "" }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.accountName.trim()) {
      Swal.fire("Required", "Account Name is required.", "warning"); return;
    }
    setSaving(true);
    try {
      if (editRecord?.accountID || editRecord?.id) {
        await dispatch(updateAccountHeadThunk({ id: editRecord.accountID || editRecord.id, data: form })).unwrap();
      } else {
        await dispatch(createAccountHeadThunk(form)).unwrap();
      }
      Swal.fire({ toast: true, position: "top-end", icon: "success", title: `Account Head ${editRecord ? "updated" : "added"} successfully`, showConfirmButton: false, timer: 2000 });
      onClose();
    } catch (err) {
      Swal.fire("Error", getApiErrorMessage(err, "Failed to save account head."), "error");
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 custom-modal-header">
              <div className="page-title">
                <h4>{editRecord ? "Edit Account Head" : "Add Account Head"}</h4>
              </div>
              <button type="button" className="close" onClick={onClose}><span>×</span></button>
            </div>
            <div className="modal-body custom-modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12 mb-3">
                    <label className="form-label">Account Name <span className="text-danger">*</span></label>
                    <input className="form-control" value={form.accountName} onChange={set("accountName")} placeholder="e.g. Rent, Salary, Medicine Purchase" />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <label className="form-label">Description</label>
                    <textarea className="form-control" rows={2} value={form.description} onChange={set("description")} placeholder="Optional description" />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">Status</label>
                    <Select classNamePrefix="react-select" options={statusOptions}
                      value={statusOptions.find((o) => o.value === form.status) || null}
                      onChange={setSelect("status")} />
                  </div>
                </div>
                <div className="modal-footer-btn">
                  <button type="button" className="btn btn-cancel me-2" onClick={onClose}>Cancel</button>
                  <button type="submit" className="btn btn-submit" disabled={saving}>
                    {saving ? "Saving..." : editRecord ? "Save Changes" : "Add Account Head"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} />
    </>
  );
};

export default AccountHeadModal;
